export enum HandballGoalAttribute {
  PenaltyGoal = 467,
  SixMeter = 992,
  NineMeter = 993,
  Air = 994,
  Ground = 995,
  LeftSide = 996,
  RightSide = 997,
  Center = 998,
  LeftWing = 999,
  RightWing = 1000,
  FastAttack = 1001,
  AfterTurnover = 1002,
  EmptyNetGoal = 1003,
  Pivot = 1004,
  Breakthrough = 1005,
  UpperLeft = 1006,
  UpperRight = 1007,
  UpperMiddle = 1008,
  BottomLeft = 1009,
  BottomRight = 1010,
  BottomMiddle = 1011,
}
